import Image from 'next/image';
import React from 'react';

import { fontStyles } from '@/styles/typography';

import { ArrowUpRightIcon } from '@/ui/Icons/ArrowUpRightIcon';

const ARTICLE_IMAGE_WIDTH = 224;
const ARTICLE_IMAGE_HEIGHT = 148;
/**
 * Props for the RelatedArticleLink component - USDC SEO Experiment.
 */
interface RelatedArticleLinkProps {
  href: string;
  imgSrc: string;
  title: string;
  subtitle: string;
}
/**
 * RelatedArticleLink component displays a card with an image and an arrow icon
 * which appears on hover in the right corner.
 */
export const RelatedArticleLink = ({ href, imgSrc, title, subtitle }: RelatedArticleLinkProps) => (
  <div className="relative flex-[0_0_auto] snap-start align-middle overflow-hidden w-[224px]">
    <a href={href} target="_blank" rel="noopener noreferrer">
      <Image
        src={imgSrc}
        alt="related article link image"
        className="border-token-gray-400 border border-solid rounded-md"
        width={ARTICLE_IMAGE_WIDTH}
        height={ARTICLE_IMAGE_HEIGHT}
      />
      <div className="hover-overlay">
        {' '}
        <ArrowUpRightIcon className="arrow-up-icon" />
      </div>
      <h2
        className={fontStyles({
          variant: 'LABEL_MD',
          class: [
            'mt-3',
            'mb-2',
            'leading-5',
            'h-4',
            'text-wrap',
            'overflow-hidden',
            'flex',
            '[-webkit-box-orient:vertical]',
            '[display:-webkit-box]',
            '[-webkit-line-clamp:1]',
          ],
        })}
      >
        {title}
      </h2>
      <p
        className={fontStyles({
          variant: 'CAPTION',
          class: [
            'text-token-gray-800',
            'pt-1',
            'text-wrap',
            '[display:-webkit-box]',
            '[-webkit-box-orient:vertical]',
            '[-webkit-line-clamp:2]',
          ],
        })}
      >
        {subtitle}
      </p>
    </a>
  </div>
);
